export const FLAG_GETTING_LEGAL_MANIFEST_TICKETS = 'FLAG_GETTING_LEGAL_MANIFEST_TICKETS';
export const GET_LEGAL_MANIFEST_TICKETS = 'GET_LEGAL_MANIFEST_TICKETS';
export const CLEAR_LEGAL_MANIFEST_TICKETS = 'CLEAR_LEGAL_MANIFEST_TICKETS';
export const FLAG_LEGAL_MANIFEST_TICKET_ACTIVITY = 'FLAG_LEGAL_MANIFEST_TICKET_ACTIVITY';
export const GET_LEGAL_MANIFEST_TICKET = 'GET_LEGAL_MANIFEST_TICKET';
export const CLEAR_LEGAL_MANIFEST_TICKET = 'CLEAR_LEGAL_MANIFEST_TICKET';
